import { ArrowUpward, CheckCircle, Print, PrintOutlined, QueryStatsOutlined, Search, Shop2Outlined, ShopOutlined } from '@mui/icons-material';
import { Autocomplete, Avatar, Box, Button, Card, CardContent, Chip, Divider, Grid, InputAdornment, Pagination, Step, StepLabel, Stepper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import { FcProcess } from "react-icons/fc";
import { GiTakeMyMoney } from "react-icons/gi";

const dummyOrders = [
    {
        orderId: "WW1256",
        customerName: "Rohit Sharma",
        totalAmount: 2499,
        totalProducts: 2,
        status: "Processing",
        orderDate: "Apr 24, 2024"
    },
    {
        orderId: "WW1255",
        customerName: "Arjun Mehta",
        totalAmount: 1999,
        totalProducts: 1,
        status: "Confirmed",
        orderDate: "Apr 24, 2024"
    },
    {
        orderId: "WW1254",
        customerName: "Vikram Singh",
        totalAmount: 4597,
        totalProducts: 3,
        status: "Shipped",
        orderDate: "Apr 23, 2024"
    },
    {
        orderId: "WW1253",
        customerName: "Neeraj Patel",
        totalAmount: 1799,
        totalProducts: 1,
        status: "Delivered",
        orderDate: "Apr 23, 2024"
    },
    {
        orderId: "WW1252",
        customerName: "Aman Verma",
        totalAmount: 3398,
        totalProducts: 2,
        status: "Cancelled",
        orderDate: "Apr 22, 2024"
    }
];
function VenderOrders() {
    const [search, setSearch] = useState("")
    const [selectedCategory, setSelectedCategory] = useState(null)
    const [selectedOrder, setSelectedOrder] = useState(dummyOrders[0])
    const totalOrders = dummyOrders.length;
    const [page, setPage] = useState(1);
    const limit = dummyOrders.length
    const categoryOptions = [
        { id: "all", categoryName: "All" },
        { id: "processing", categoryName: "Processing" },
        { id: "delivered", categoryName: "Delivered" },
        { id: "shipped", categoryName: "Shipped" },
    ];

    return (
        <Box className='h-100 p-3' sx={{ minHeight: 'calc(100vh - 65px)' }}>
            <Grid container spacing={1.5} className='w-100 mb-2'>
                <Grid size={{ xs: 12, lg: 'grow' }} sx={{ minHeight: '138px' }} className='bg-main position-relative border-main border-10 p-3'>
                    <Typography className='fs-14 text-white'>Total Orders</Typography>
                    <Box className="d-flex align-items-start justify-content-between mt-2">
                        <Box>
                            <Typography className='text-white fs-20 fw-bold whitespace'>N/A</Typography>
                            <Typography className='text-success fs-14'><ArrowUpward className='text-sucess' /> N/A</Typography>
                            <Typography className='text-white fs-12'>vs last 7 days</Typography>
                        </Box>
                        <Box className='p-2' sx={{ background: 'var(--blue-light-color)', borderRadius: '50px' }}>
                            <ShopOutlined className='fs-28' sx={{ color: 'var(--blue-color)' }} />
                        </Box>
                        {/* <Box component={'img'} src=''></Box> */}
                    </Box>
                </Grid>
                <Grid size={{ xs: 6, lg: 'grow' }} sx={{ minHeight: '138px' }} className='bg-main border-10 border-main p-2 p-md-3'>
                    <Typography className='fs-14 text-white'>Processing</Typography>
                    <Box className="d-flex align-items-start justify-content-between mt-2">
                        <Box>
                            <Typography className='text-white fs-20 fw-bold whitespace'>N/A</Typography>
                            <Typography className='text-success fs-14'><ArrowUpward className='text-sucess' /> N/A</Typography>
                            <Typography className='text-white fs-12'>vs last 7 days</Typography>
                        </Box>
                        <Box className='p-2' sx={{ background: 'var(--purple-light-color)', borderRadius: '50px' }}>
                            {/* <QueryStatsOutlined className='text-yellow fs-28' /> */}
                            {FcProcess({ size: 32, color: 'var(--purple-color)' })}
                        </Box>
                        {/* <Box component={'img'} src=''></Box> */}
                    </Box>
                </Grid>
                <Grid size={{ xs: 6, lg: 'grow' }} sx={{ minHeight: '138px' }} className='bg-main border-10 border-main p-2 p-md-3'>
                    <Typography className='fs-14 text-white'>Delivered</Typography>
                    <Box className="d-flex align-items-start justify-content-between mt-2 ">
                        <Box>
                            <Typography className='text-white fs-20 fw-bold'>N/A</Typography>
                            <Typography className='text-success fs-14'><ArrowUpward className='text-sucess' /> N/A</Typography>
                            <Typography className='text-white fs-12'>vs last 7 days</Typography>
                        </Box>
                        <Box className='p-2' sx={{ background: 'var(--third-light-color)', borderRadius: '50px' }}>
                            <CheckCircle className='fs-28' sx={{ color: 'var(--third-color)' }} />
                        </Box>
                        {/* <Box component={'img'} src=''></Box> */}
                    </Box>
                </Grid>
                <Grid size={{ xs: 6, lg: 'grow' }} sx={{ minHeight: '138px' }} className='bg-main border-10 border-main p-2 p-md-3'>
                    <Typography className='fs-14 text-white'>Total Revenue</Typography>
                    <Box className="d-flex align-items-start justify-content-between mt-2 ">
                        <Box>
                            <Typography className='text-white fs-20 fw-bold'>N/A</Typography>
                            <Typography className='text-success fs-14'><ArrowUpward className='text-sucess' /> N/A</Typography>
                            <Typography className='text-white fs-12'>vs last 7 days</Typography>
                        </Box>
                        <Box className='p-2' sx={{ background: 'var(--secondary-light-color)', borderRadius: '50px' }}>
                            {GiTakeMyMoney({ size: 32, color: 'var(--secondary-color)' })}
                        </Box>
                        {/* <Box component={'img'} src=''></Box> */}
                    </Box>
                </Grid>
            </Grid>

            <Grid container spacing={1}>
                <Grid size={{ xs: 12, lg: 4 }} className="bg-main border-10 d-flex flex-column border-main p-2 p-md-3">
                    {dummyOrders ? (
                        <Box>
                            <Typography
                                className='fs-20 text-white fw-bold mb-3'>
                                All Orders (245)
                            </Typography>
                            <Box className="d-flex form gap-2 mb-3">
                                <TextField
                                    sx={{ flex: 1 }}
                                    size="small"
                                    placeholder="Search products..."
                                    value={search}
                                    onChange={(e) => {
                                        setSearch(e.target.value);
                                        // setPage(1);
                                    }}
                                    slotProps={{
                                        input: {
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <Search className="text-grey" />
                                                </InputAdornment>
                                            ),
                                        },
                                    }}
                                />

                                <Autocomplete
                                    className="autoselect"
                                    size="small"
                                    sx={{ minWidth: 130 }}
                                    options={categoryOptions}
                                    value={selectedCategory}
                                    getOptionLabel={(option) => option.categoryName || ""}
                                    onChange={(_, value: any) => {
                                        setSelectedCategory(value);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Select Category"
                                        />
                                    )}
                                />
                            </Box>

                            {/* Product List */}
                            {dummyOrders.map((item, index) => (
                                <Card
                                    className="border-10 py-0"
                                    key={index}
                                    sx={{
                                        mb: 1,
                                        cursor: "pointer",
                                        background:
                                            selectedOrder?.orderId === item.orderId
                                                ? "var(--secondary-light-color)"
                                                : "transparent",
                                        border:
                                            selectedOrder?.orderId === item.orderId
                                                ? "1px solid var(--secondary-color)"
                                                : "1px solid var(--text-grey)",
                                    }}
                                    onClick={() => setSelectedOrder(item)}
                                >
                                    <CardContent className="d-flex p-2 px-xl-3 align-items-center justify-content-between">
                                        <Box className="d-flex align-items-center gap-3">
                                            <Avatar
                                                sx={{
                                                    width: 42,
                                                    height: 42,
                                                    bgcolor: "var(--secondary-color)",
                                                    color: "#000"
                                                }}
                                            >
                                                {item.customerName.charAt(0)}
                                            </Avatar>

                                            <Box>
                                                <Typography className="text-white fw-semibold fs-16">
                                                    #{item.orderId}
                                                </Typography>

                                                <Typography className="fs-14 text-grey">
                                                    {item.customerName}
                                                </Typography>

                                                <Typography className="fs-14 text-grey">
                                                    {item.totalProducts} Product{item.totalProducts > 1 ? "s" : ""}
                                                </Typography>
                                            </Box>
                                        </Box>

                                        <Box className="text-end">
                                            <Typography className="text-white fw-semibold">
                                                ${item.totalAmount.toLocaleString()}
                                            </Typography>

                                            <Typography className="fs-12 text-grey">
                                                {item.orderDate}
                                            </Typography>

                                            <Chip
                                                label={item.status}
                                                size="small"
                                                sx={{
                                                    mt: 1,
                                                    borderRadius: "5px",
                                                    background:
                                                        item.status === "Processing"
                                                            ? "var(--secondary-light-color)"
                                                            : item.status === "Confirmed"
                                                                ? "var(--blue-light-color)"
                                                                : item.status === "Shipped"
                                                                    ? "var(--purple-light-color)"
                                                                    : item.status === "Delivered"
                                                                        ? "var(--third-light-color)"
                                                                        : "#f4433620",
                                                    color:
                                                        item.status === "Processing"
                                                            ? "var(--secondary-color)"
                                                            : item.status === "Confirmed"
                                                                ? "var(--blue-color)"
                                                                : item.status === "Shipped"
                                                                    ? "var(--purple-color)"
                                                                    : item.status === "Delivered"
                                                                        ? "var(--third-color)"
                                                                        : "#f44336",
                                                }}
                                            />
                                        </Box>
                                    </CardContent>
                                </Card>
                            ))}

                            {/* Pagination */}
                            <Box className="d-flex justify-content-between align-items-center mt-3">
                                <Typography className="fs-12 text-grey">
                                    Showing {(page - 1) * limit + 1} to{" "}
                                    {Math.min(page * limit, totalOrders)} of {totalOrders} orders
                                </Typography>

                                <Pagination
                                    count={Math.ceil(totalOrders / limit)}
                                    page={page}
                                    onChange={(_, value) => setPage(value)}
                                    color="secondary"
                                    shape="rounded"
                                />
                            </Box>
                        </Box>
                    ) : (<Box className='h-100 d-flex align-items-center justify-content-center'><Typography className='text-white fs-16 mx-auto'>No Products Found</Typography></Box>)}
                </Grid>
                <Grid size={{ xs: 12, lg: 8 }} className="bg-main border-10 d-flex flex-column border-main p-2 p-md-3">
                    <Box className='d-flex align-items-center justify-content-between mb-3'>
                        <Box className='d-flex align-items-center gap-2'>
                            <Typography className='fs-24 text-white fw-bold'>Order #WWW1256</Typography>
                            {/* <Chip
                                label={"Processing"}
                                size="small"
                                sx={{
                                    mt: 1,
                                    borderRadius: "5px",
                                    background:
                                        item.status === "Processing"
                                            ? "var(--secondary-light-color)"
                                            : item.status === "Confirmed"
                                                ? "var(--blue-light-color)"
                                                : item.status === "Shipped"
                                                    ? "var(--purple-light-color)"
                                                    : item.status === "Delivered"
                                                        ? "var(--third-light-color)"
                                                        : "#f4433620",
                                    color:
                                        item.status === "Processing"
                                            ? "var(--secondary-color)"
                                            : item.status === "Confirmed"
                                                ? "var(--blue-color)"
                                                : item.status === "Shipped"
                                                    ? "var(--purple-color)"
                                                    : item.status === "Delivered"
                                                        ? "var(--third-color)"
                                                        : "#f44336",
                                }}
                            /> */}
                        </Box>
                        <Box className='border-main text-white border-10 px-3 py-2'><PrintOutlined />&nbsp; Print Invoice</Box>
                    </Box>
                    <Grid container className='bg-grey border-10 border-main' sx={{ p: 2 }}>
                        <Grid className='px-4 border-right-light-main' size={{ xs: 12, md: 6, lg: 4 }}>
                            <Typography className='fs-16 text-grey' gutterBottom>Order Date</Typography>
                            <Typography className='fs-14 text-white'>Apr 24, 2024 . 10:24 AM</Typography>
                        </Grid>
                        <Grid className='px-4 border-right-light-main' size={{ xs: 12, md: 6, lg: 4 }}>
                            <Typography className='fs-16 text-grey' gutterBottom>Payment Method</Typography>
                            <Typography className='fs-14 text-white'>UPI (Paid) <CheckCircle className='fs-16 bg-light-green border-10' sx={{ color: "var(--third-color)" }} /></Typography>
                        </Grid>
                        <Grid className='px-4' size={{ xs: 12, md: 6, lg: 4 }}>
                            <Typography className='fs-16 text-grey' gutterBottom>Total Amount</Typography>
                            <Typography className='fs-20 text-white' sx={{ lineHeight: 'auto' }}>$2,499</Typography>
                        </Grid>
                    </Grid>
                    <Grid container className='mt-2' spacing={1}>
                        <Grid size={{ xs: 12, md: 4 }} className='p-2 bg-grey border-main border-10'>
                            <Typography className='fs-16 text-white p-2 fw-bold'>Customer Information</Typography>
                            <Box className='d-flex align-items-start gap-2 p-2'>
                                <Avatar sx={{ height: '50px', width: "50px" }}></Avatar>
                                <Box>
                                    <Typography className='fs-16 text-white' gutterBottom>Rohit Sharma</Typography>
                                    <Typography className='fs-14 text-grey' gutterBottom>rohit@sharma@gmail.com</Typography>
                                    <Typography className='fs-14 text-grey' gutterBottom>+91 98765 43210</Typography>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }} className='p-2 bg-grey border-main border-10'>
                            <Typography className='fs-16 text-white p-2 pb-1 fw-bold'>Shipping Address</Typography>
                            <Box className='d-flex align-items-start gap-2 p-2'>
                                <Box>
                                    <Typography className='fs-16 text-white' gutterBottom>Rohit Sharma</Typography>
                                    <Typography className='fs-14 text-grey' gutterBottom>22, Green Park Society Near Stadium Road Ahmedabad, Gujarat-380015 India</Typography>
                                    <Typography className='fs-14 text-grey' gutterBottom>+91 98765 43210</Typography>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }} className='p-2 bg-grey border-main border-10'>
                            <Typography className='fs-16 text-white p-2 pb-1 fw-bold'>Billing Address</Typography>
                            <Box className='d-flex align-items-start gap-2 p-2'>
                                <Box>
                                    <Typography className='fs-16 text-white' gutterBottom>Rohit Sharma</Typography>
                                    <Typography className='fs-14 text-grey' gutterBottom>22, Green Park Society Near Stadium Road Ahmedabad, Gujarat-380015 India</Typography>
                                    <Typography className='fs-14 text-grey' gutterBottom>+91 98765 43210</Typography>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid size={{ xs: 12, md: 7 }} className="bg-grey border-main border-10 p-3">
                            <Typography className="fs-16 text-white fw-bold mb-3">
                                Ordered Products (2)
                            </Typography>

                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className='border-light-bottom'><Typography className='text-grey'>Product</Typography></TableCell>
                                        <TableCell className='border-light-bottom'><Typography className='text-grey'>Price</Typography></TableCell>
                                        <TableCell className='border-light-bottom'><Typography className='text-grey'>Qty</Typography></TableCell>
                                        <TableCell className='border-light-bottom'><Typography className='text-grey'>Total</Typography></TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>

                                    {[1, 2].map((item) => (
                                        <TableRow   key={item}>
                                            <TableCell className='border-light-bottom py-2 text-white'>
                                                <Box className="d-flex align-items-center gap-2">
                                                    <Avatar
                                                        variant="rounded"
                                                        sx={{ width: 40, height: 40 }}
                                                    />

                                                    <Box>
                                                        <Typography className="fs-14 text-white">
                                                            Home Jersey 2024/25
                                                        </Typography>

                                                        <Typography className="fs-12 text-grey">
                                                            Black / M
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </TableCell>

                                            <TableCell className='border-light-bottom  py-2 text-white'>
                                                ₹2,499
                                            </TableCell>

                                            <TableCell className='border-light-bottom py-2 text-white'>
                                                1
                                            </TableCell>

                                            <TableCell className='border-light-bottom py-2 text-white'>
                                                ₹2,499
                                            </TableCell>
                                        </TableRow>
                                    ))}

                                </TableBody>
                            </Table>

                            <Box className="d-flex justify-content-between mt-3">
                                <Typography className="text-grey fs-14">
                                    Total Items : 2
                                </Typography>

                                <Typography className="text-white fw-bold">
                                    Total Amount ₹2,499
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid size={{ xs: 12, md: 5 }} className="bg-grey step border-main border-10 p-3">

                            <Typography className="fs-16 text-white fw-bold mb-3">
                                Order Status Timeline
                            </Typography>

                            <Stepper orientation="vertical" activeStep={2}>

                                <Step completed>
                                    <StepLabel>Order Placed</StepLabel>
                                </Step>

                                <Step completed>
                                    <StepLabel>Payment Received</StepLabel>
                                </Step>

                                <Step active>
                                    <StepLabel>Processing</StepLabel>
                                </Step>

                                <Step>
                                    <StepLabel>Packed</StepLabel>
                                </Step>

                                <Step>
                                    <StepLabel>Shipped</StepLabel>
                                </Step>

                                <Step>
                                    <StepLabel>Delivered</StepLabel>
                                </Step>

                            </Stepper>

                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }} className='p-2 bg-grey border-main border-10'>
                            <Typography className='fs-16 text-white p-2 pb-1 fw-bold'>Payment Summary</Typography>
                            <Box className='d-flex align-items-start gap-2 p-2'>
                                <Box className='w-100'>
                                    <Box className='d-flex w-100 align-items-center  justify-content-between'>
                                        <Typography className='fs-14 text-grey' gutterBottom>Subtotal</Typography>
                                        <Typography className='fs-16 text-white' gutterBottom>$5,498</Typography>
                                    </Box>
                                    <Box className='d-flex w-100 align-items-center  justify-content-between'>
                                        <Typography className='fs-14 text-grey' gutterBottom>Tax (5%)</Typography>
                                        <Typography className='fs-16 text-white' gutterBottom>$89</Typography>
                                    </Box>
                                    <Box className='d-flex w-100 align-items-center justify-content-between'>
                                        <Typography className='fs-14 text-grey' gutterBottom>Discount</Typography>
                                        <Typography className='fs-16 text-green' gutterBottom>-$8</Typography>
                                    </Box>
                                    <Divider className='border-white mb-2 mt-0' />
                                    <Box className='d-flex w-100 align-items-center justify-content-between'>
                                        <Typography className='fs-14 text-grey' gutterBottom>Total Amount</Typography>
                                        <Typography className='fs-16 text-green' gutterBottom>$2,499</Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }} className="bg-grey border-main border-10 p-3">
                            <Typography className="fs-16 text-white fw-bold mb-3">
                                Order Notes
                            </Typography>

                            <Typography className="text-grey fs-14">
                                Please deliver between 9 AM - 6 PM.
                            </Typography>

                            <Typography className="text-grey fs-14 mb-3">
                                Customer requested fast delivery.
                            </Typography>

                            {/* <Box className="d-flex form gap-2">

                                <TextField
                                    className='flex-1'
                                    fullWidth
                                    size="small"
                                    placeholder="Add note..."
                                />

                                <Button variant="contained" className='btn-light-yellow'>
                                    Add Note
                                </Button>
                            </Box> */}

                        </Grid>

                        <Grid size={{ xs: 12, md: 4 }} className="bg-grey border-main border-10 p-3">

                            <Typography className="fs-16 text-white fw-bold mb-3">
                                Customer Statistics
                            </Typography>

                            <Grid container>

                                <Grid size={4}>
                                    <Typography className="text-grey fs-12">
                                        Total Orders
                                    </Typography>

                                    <Typography className="text-white fs-22 fw-bold">
                                        12
                                    </Typography>
                                </Grid>

                                <Grid size={4}>
                                    <Typography className="text-grey fs-12">
                                        Total Spent
                                    </Typography>

                                    <Typography className="text-white fs-22 fw-bold">
                                        ₹24,500
                                    </Typography>
                                </Grid>

                                <Grid size={4}>
                                    <Typography className="text-grey fs-12">
                                        Last Order
                                    </Typography>

                                    <Typography className="text-white fs-22 fw-bold">
                                        5 days
                                    </Typography>
                                </Grid>

                            </Grid>

                            <Button
                                fullWidth
                                variant="contained"
                                sx={{ mt: 4 }}
                                className='btn-light-yellow'
                            >
                                View Customer
                            </Button>

                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box >
    )
}

export default VenderOrders;
